<template>
  <div>
    <div  style="display: flex;justify-content: flex-end;">
      <el-dropdown @command="handleCommand">
        <el-button type="primary">
          添加设置<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" >
          <el-dropdown-item command="1">上下班打卡</el-dropdown-item>
          <el-dropdown-item command="3">外出打卡</el-dropdown-item>
          
        </el-dropdown-menu>
      </el-dropdown>
    </div>
      <div class="clock-list">
          <div class="unit"  v-for="(item, index) in pageProps.records" :key="index">
              <div>
                <div class="title">项目：{{item.project_name}}</div>
                <div class="title">职位：{{item.job_name}}</div>  
                <div class="title">{{item.title}}</div>
              </div>
              <div class="op">
                 <span v-if="item.type==1||item.type==2">上下班打卡</span> 
                 <span v-if="item.type==3">外出打卡</span> 
                 <p class="btns"> 
                    <span @click="delClock(item)" style="cursor: pointer;">删除</span>
                    <span @click="editClock(item)" style="cursor: pointer;">编辑</span>
                </p>
              </div>
          </div>
      </div>

      <div style="text-align:center;padding:20px">
        <!--分页-->
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageProps.total"
          :page-size="pageProps.pageSize"
          :page-sizes="[5, 10, 50, 100]"
          :current-page="pageProps.pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>

    </div>
    
</template>

<script>
import { clockSetList,clockSetDel } from "@/api/director/clock/index.js";

export default {
    name: "Director-Work-CLock",
    data() {
      return {
       
        pageProps: {
          records:[],
          total: 0,
          pageSize: 10,
          pageNum: 1
        },

        searchFormData:{
          project_id:"",
          name:"",
          page:0,
          limit:0
        }

      }
    },

    mounted () {
      console.log("this.$route.query",this.$route.query);
  
      if(this.$route.query&&this.$route.query.project_id){
        this.searchFormData.project_id=this.$route.query.project_id;
        this.fetchData();
      }
     
    },


    methods: {

      editClock(item){
       
        if(item.type==1){
         // this.$router.push({path:'/director-workmaster-clock-edit-in',query:{id:item.id}});

           const routeData = this.$router.resolve({
              name: '/director-workmaster-clock-edit-in',
              query:{id:item.id} 
            })
            window.open(routeData.href, '_blank')
        }else{
         // this.$router.push({path:'/director-workmaster-clock-edit-out',query:{id:item.id}});
          const routeData = this.$router.resolve({
              name: '/director-workmaster-clock-edit-out',
              query:{id:item.id} 
            })
            window.open(routeData.href, '_blank')
        }
      },

      delClock(item){
        var that=this;
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          clockSetDel({id:item.id}).then((response) => {
              console.log(response);
              if(response.code==200){
                  that.fetchData();
                
              }
            });
          
        }).catch(() => {
        
        });
      },

      clockList(){
        this.$router.push({path:'/director-workmaster-clock-day',query:{}});
        
      },

      handleCommand(command){
        this.addClock(command);
      },
      addClock(type){
        if(type==1){
          console.log(11111)
          //this.$router.push({path:'/director-workmaster-clock-edit-in',query:{project_id:this.searchFormData.project_id}});

          const routeData = this.$router.resolve({
              name: 'director-workmaster-clock-edit-in',
              query:{project_id:this.searchFormData.project_id}}
            )
            window.open(routeData.href, '_blank')

        }else{
         // this.$router.push({path:'/director-workmaster-clock-edit-out',query:{project_id:this.searchFormData.project_id}});

          const routeData = this.$router.resolve({
              name: 'director-workmaster-clock-edit-out',
              query:{project_id:this.searchFormData.project_id}}
            )
            window.open(routeData.href, '_blank')
        }
      },


      fetchData(){
        var that = this;
        that.searchFormData.page=that.pageProps.pageNum;
        that.searchFormData.limit=that.pageProps.pageSize;

        clockSetList(that.searchFormData).then((response) => {
          console.log(response);
          if(response.code==200){
            that.pageProps.records = response.data.data;
            that.pageProps.total = response.data.total;
          }else{
            that.$message.error(response.msg?response.msg:"请求错误");
          }
         
        });
      },

       // 当前页变更
      handleCurrentChange(num) {
        this.pageProps.pageNum = num
        this.fetchData()
      },


      // 每页显示页面数变更
      handleSizeChange(size) {
        this.pageProps.pageSize = size
        this.fetchData()
      },
      
    }
  }
</script>
<style lang="scss" scoped>


  .clock-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      display: flex;
      justify-content: space-between;
      background: #F6F6F6;
      align-items: center;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;
      border-radius: 8px;

      &:hover{
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        background: #FFFFFF;
      }
      .title{
        font-size: 14px;
        padding: 5px;
      }
      .job{
        max-width: 300px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .op{
        display:flex;
        align-items: center;
        font-size: 14px;
      }
      .btns{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-left: 20px;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin-left: 20px;
          background: none;
        }
      }
    }
  }


  .edit-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      background: #F6F6F6;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;

      .title{
        text-align: center;
      }

      .desc{
        text-align: center;
      }

      .btns{
        text-align: center;
        align-items: center;
        margin-left: 20px;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin-left: 20px;
          background: none;
        }
      }
      


    }
  }


</style>